import { ArrowRight } from "@phosphor-icons/react";
import { C } from "@/brand/tokens";

/**
 * ConsultationBanner — reusable closing CTA for interior pages.
 *
 * A compact Deep Mineral Blue band that echoes the homepage's
 * consultation chamber without duplicating the full institutional
 * intake form. Sends the visitor to the homepage's contact form.
 */
export function ConsultationBanner({
  eyebrow = "Book a consultation",
  title = "Tell us about the moment your organization is in.",
  body = "Faith 1st reads every submission personally. We respond within two business days with either a time to talk or a thoughtful referral if we're not the right fit.",
  ctaLabel = "Book a consultation",
  ctaHref = "/concept-e#contact",
}) {
  return (
    <section
      data-testid="consultation-banner"
      style={{ background: C.surfacePrimary, color: C.textOnDark }}
    >
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12 py-20 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-7">
              <span
                aria-hidden="true"
                className="inline-block h-px w-14"
                style={{ background: C.accentMetal }}
              />
              <p
                className="font-inter text-[11px] uppercase font-semibold"
                style={{
                  color: C.accentMetal,
                  letterSpacing: "0.28em",
                }}
              >
                {eyebrow}
              </p>
            </div>
            <h2
              className="font-cormorant"
              style={{
                color: C.textOnDark,
                fontSize: "clamp(1.9rem, 3.2vw, 2.8rem)",
                fontWeight: 400,
                lineHeight: 1.06,
                letterSpacing: "-0.012em",
              }}
            >
              {title}
            </h2>
            <p
              className="mt-6 font-inter leading-[1.7] max-w-[54ch]"
              style={{ color: C.whiteOnDark, fontSize: "1rem" }}
            >
              {body}
            </p>
          </div>
          <div className="lg:col-span-5 lg:justify-self-end">
            <a
              href={ctaHref}
              data-testid="consultation-banner-cta"
              className="group inline-flex items-center gap-3 px-7 py-4 font-inter text-[12px] uppercase font-semibold transition-colors"
              style={{
                background: C.accentMetal,
                color: C.bgDark,
                letterSpacing: "0.24em",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = C.textOnDark)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = C.accentMetal)
              }
            >
              {ctaLabel}
              <ArrowRight
                size={14}
                weight="bold"
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
